import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Car, Home } from "lucide-react";
import { SEO } from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="Page Not Found - Car Age Calculator"
        description="The page you requested does not exist. Return to the car age calculator and keep going."
        keywords={["404", "page not found", "car age calculator"]}
        canonicalUrl={location.pathname}
        noIndex
      />

      <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(99,102,241,0.18),_transparent_28%),linear-gradient(135deg,_#eff6ff,_#f8fafc)] px-4 py-16 text-slate-900 dark:bg-[radial-gradient(circle_at_top,_rgba(139,92,246,0.18),_transparent_28%),linear-gradient(135deg,_#020617,_#111827)] dark:text-white">
        <div className="mx-auto flex min-h-[70vh] max-w-3xl items-center justify-center">
          <div className="w-full rounded-[2rem] border border-white/70 bg-white/80 p-8 text-center shadow-2xl backdrop-blur-xl dark:border-white/10 dark:bg-white/5">
            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-3xl bg-indigo-50 text-indigo-700 dark:bg-white/10 dark:text-white">
              <Car className="h-7 w-7" />
            </div>
            <p className="text-sm uppercase tracking-[0.35em] text-indigo-600 dark:text-purple-300">404</p>
            <h1 className="mt-3 text-3xl font-semibold sm:text-4xl">This road does not exist</h1>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              The route you opened is not available. Return home to calculate a vehicle age, review milestones, or share a result.
            </p>

            <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-900 px-5 py-3 text-sm font-medium text-white transition hover:-translate-y-0.5 hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
              >
                <Home className="h-4 w-4" />
                Back to home
              </Link>
              <button
                type="button"
                onClick={() => window.history.back()}
                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-medium text-slate-700 transition hover:-translate-y-0.5 hover:bg-slate-50 dark:border-white/10 dark:bg-white/5 dark:text-white dark:hover:bg-white/10"
              >
                <ArrowLeft className="h-4 w-4" />
                Go back
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
